
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-master-confirmed-message',
  templateUrl: './master-confirmed-message.component.html',
  styleUrls: ['./master-confirmed-message.component.scss']
})
export class MasterConfirmedMessageComponent {

  constructor(public dialogRef: MatDialogRef<MasterConfirmedMessageComponent>) {}

}
